import React from 'react';
import PropTypes from 'prop-types';

import { propTypes as i18nPropTypes } from '../../../../../hocs/intlEquipped';

import { orCondition } from '../../../../../util/helpers';
import statuses from '../../../../../constants/statuses';
import { paymentPropType, productPropType, statusPropType } from '../../../../../types/subscription';

import { isPaymentSourceITunes } from '../../../utils/helpers';
import { formatRecurringBilling, getPriceAndDateByConditions } from '../helpers';

import DetailsHeader from '../DetailsHeader';
import ITunesDetailsContent from '../ITunesDetailsContent';
import DefaultDetailsContent from '../DefaultDetailsContent';
import NonInstantDetailsContent from '../NonInstantDetailsContent';
import { useTranslation } from '../../../../../vNext/hooks/useTranslation/useTranslation';

const {
    ACTIVE_TERMED_DISCONTINUED,
    EMPTY,
    EXPIRED_EVERGREEN,
    EXPIRED_TERMED,
} = statuses;

const Details = ({ status, product, payment, theme, i18n }) => {
    const { price, date } = getPriceAndDateByConditions({ product, payment, i18n });
    const { isDifferentPayer } = payment;
    const { t } = useTranslation();

    const DetailsContent = orCondition(
        [isDifferentPayer, () => (
            <div className={ theme.differentPayerInfo }>{t('subscription.differentPayerInfo')}</div>
        )],
        [isPaymentSourceITunes({ payment }), ITunesDetailsContent],
        [payment.nonInstant, NonInstantDetailsContent],
        [true, DefaultDetailsContent]
    );

    if (![EMPTY, EXPIRED_TERMED, EXPIRED_EVERGREEN, ACTIVE_TERMED_DISCONTINUED].includes(status)) {
        const recurringBilling = formatRecurringBilling({ product, payment, i18n });
        return (
            <div className={ theme.detailsContent }>
                { ((price && date) || recurringBilling || isDifferentPayer) && (
                    <DetailsHeader text={ i18n.formatMessage('subscription.detailsHeader') } />
                )}
                <DetailsContent product={ product } payment={ payment } theme={ theme } />
            </div>
        );
    }

    return null;
};

Details.propTypes = {
    status: statusPropType.isRequired,
    product: productPropType.isRequired,
    payment: paymentPropType.isRequired,
    theme: PropTypes.shape({}),
    i18n: i18nPropTypes,
};

export default Details;
